export default __webpack_public_path__ + "40e27ce86e492ae65de7707894bb8077.jpeg";